module.exports = __webpack_public_path__ + "static/media/cancel.637e250c.svg";